import iconNavDownArrow from '@ui5/webcomponents-icons/dist/navigation-down-arrow.js';
import iconNavRightArrow from '@ui5/webcomponents-icons/dist/navigation-right-arrow.js';
import React from 'react';
import { TextAlign } from '../../../../enums/index.js';
import { Icon } from '../../../../webComponents/index.js';
const tableGroupExpandCollapseIcon = {
  color: 'var(--sapContent_IconColor)',
  height: '0.75rem',
  width: '0.75rem',
  padding: '0.625rem',
  display: 'block'
};
export const Grouped = props => {
  const {
    cell,
    row,
    webComponentsReactProperties
  } = props;
  const {
    translatableTexts
  } = webComponentsReactProperties;
  const style = {};
  if (cell.column.hAlign && (cell.column.hAlign !== TextAlign.Left || cell.column.hAlign !== TextAlign.Begin)) {
    style.marginRight = 'auto';
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    ...row.getToggleRowExpandedProps({
      style,
      column: cell.column
    }),
    title: row.isExpanded ? translatableTexts.collapseNodeA11yText : translatableTexts.expandNodeA11yText
  }, /*#__PURE__*/React.createElement(Icon, {
    name: row.isExpanded ? iconNavDownArrow : iconNavRightArrow,
    style: tableGroupExpandCollapseIcon
  })), cell.render('Cell'));
};